import type React from 'react';

import { Button } from '@change/ds-core-ui';
import { ShareIcon } from '@change/ds-icons';

import { Translate, useI18n } from '@change-corgi/core-react/i18n';

import { usePhoto } from '#src/app/pages/petitionDetails/shared/hooks';

import { usePetitionHeadingMobile } from './hooks/usePetitionHeadingMobile';

export const NativeShareMobile: React.FC = () => {
	const { translate } = useI18n();
	const photo = usePhoto();
	const { data } = usePetitionHeadingMobile();

	// Suppresses the whole sticky wrapper, not just the inner button: it is a zero-height sticky
	// flex container, and leaving an empty one behind is dead layout. Per CHANGE-98647/KTD3, this
	// is gated on the arm alone, not on the video-first hero layout.
	if (data.suppressed) {
		return null;
	}

	const ShareAction = data.shareAction?.ShareAction;

	return (
		<div
			className="sticky top-0 z-29 flex h-0 justify-end"
			data-testid="native-share-mobile"
			data-qa="native-share-mobile"
		>
			{photo && ShareAction && (
				<div className="block md:hidden">
					<ShareAction>
						<Button
							aria-label={translate('corgi.petition_gamma.share.mobile_native_share')}
							iconOnly
							leadingIcon={<ShareIcon className="text-icon-strong-fixed" />}
							variant="tertiary"
							data-qa="native-share-button"
							data-testid="native-share-button"
							className="mt-4 mr-4 h-12 min-h-12 w-12 min-w-12 rounded-full border-0 bg-white p-3 shadow-[0px_2px_12px_0px_rgba(58,41,62,0.25)]"
						>
							<Translate value="corgi.petition_gamma.share.mobile_native_share" />
						</Button>
					</ShareAction>
				</div>
			)}
		</div>
	);
};
